import React, { Component } from 'react'
import IconChevronDown from 'components/Icons/ChevronDown'

import cn from 'classnames'
import s from './Table.scss'
import sText from 'components/Text/Text.scss'

export default class TableRow extends Component {
  toggleRow = () => {}
  render() {
    const { children, showToggle } = this.props
    const active = false
    return (
      <div className={cn({ [s.active]: active })}>
        <div className={s.tableRow}>
          <div className={s.tableRowInner}>
            {children}
            {showToggle && (
              <div style={{ maxWidth: '40px' }}>
                <a className={s.moreButton} onClick={() => this.toggleRow()}>
                  <IconChevronDown />
                </a>
              </div>
            )}
          </div>
        </div>
        <div className={s.tableInfoRow}>
          <div className={s.tableInfoRowInner}>
            <div className={sText.descrip1}>aaaa</div>
            <div className={s.infoRowMeta}>
              <div>
                <div>Transaction ID:</div>
                <div>aaa</div>
              </div>
              <div>
                <div>Type:</div>
                <div>aaa</div>
              </div>
              <div>
                <div>Time:</div>
                <div>aaaa</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Table/TableRow.jsx